import SiteProps from "./SiteProps"
import { DateTime } from "luxon"
export enum APPLICABLE_AT {
  ANYTIME = "anytime",
  IN_DATE_RANGE = "in_date_range",
  FROM_DATE = "from_date",
  UNTIL_DATE = "until_date",
}

type ApplicableAt = APPLICABLE_AT

export const ADDON_KIND = {
  NORMAL: "normal",
  BOOLEAN: "boolean",
  ALWAYS_APPLIED: "always-applied",
  ALWAYS_APPLIED_RECURRING: "always-applied-recurring",
  HIDDEN: "hidden",
}

type AddOnKind = (typeof ADDON_KIND)[keyof typeof ADDON_KIND]

export default interface IAddOn {
  id: string
  slug: string
  label: string
  description: string
  sort: number
  amount_in_cents: number
  kind: AddOnKind
  camping_style_id?: string
  camp_id?: string
  available_sites: SiteProps[]
  addable_camping_style_id: string | null
  is_bookable: boolean
  is_applied_nightly: boolean
  inventory_quantity: number
  sku: string
  applicable_at: ApplicableAt
  valid_from?: DateTime | null
  valid_until?: DateTime | null
}
